import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridsterModule } from 'angular2gridster';
import { UploadComponent } from './components/upload/upload.component';
import { SharedModule } from '../../shared/shared.module';
import { UploadRoutingModule } from './upload-routing.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgProgressModule } from '@ngx-progressbar/core';
import { FormsModule } from '@angular/forms';
import { FileDropModule } from 'ngx-file-drop';
import { CoreModule } from '../../core/core.module';
import { MapPopupComponent } from "./components/map-popup/map-popup.component";
import { PhotoRelatedComponent } from "./components/photo-related/photo-related.component";
import { NgxMasonryModule } from "ngx-masonry";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { UploadVideoComponent } from "./components/video/upload-video.component";
import { AuthCamerallaInterceptor } from "../../auth/interceptors/auth.interceptor";

@NgModule({
    imports: [
        CoreModule,
        CommonModule,
        HttpClientModule,
        SharedModule,
        UploadRoutingModule,
        GridsterModule.forRoot(),
        NgProgressModule,
        FormsModule,
        FileDropModule,
        NgxMasonryModule
    ],
    providers: [
        NgbActiveModal
    ],
    exports: [
        UploadComponent,
        PhotoRelatedComponent
    ],
    entryComponents: [MapPopupComponent,PhotoRelatedComponent, UploadVideoComponent],
    declarations: [
        UploadComponent,
        MapPopupComponent,
        PhotoRelatedComponent,
        UploadVideoComponent
    ]
})
export class UploadModule {
}
